exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nli[data-v-ac02ad36] {\n  cursor: pointer\n}\nli a[data-v-ac02ad36] {\n  display: inline-block;\n  width: 100%;\n}\n", ""]);

// exports
